<template>
    <div style="width: 340px;">
        <div class="form-group-input-vc biz-pre-paid-card-pc justify-content-end">
            <div class="row-cnt">
                <div class="lst-type">
                    <ul class="row no-gutters">
                        <li v-for="t in inputTSelector" :key="t.id" :value="t.id" class="col" v-on:click="setInputT(t)">
                            <div class="type-txt" :class="{ 'active': (selectInputToggle.id == t.id) }">{{ t.name }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
export default {
    name: "InputT",
    model: {
        prop: 'selectedInputT',
        event: 'updateInputT'
    },
    components: {

    },
    props: {
        selectedInputT: {
            type: { id: Number, name:String } | null ,
            required: false
        },
    },
    data () {
        return {
            inputTSelector: Constants.InputT,
        }
    },
    computed: {
        selectInputToggle: function () {
            return this.selectedInputT;
        },
    },
    methods: {
        setInputT(select){
            this.$emit('updateInputT', select);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/components/pc/Tour/InputT.vue